import { useMutation } from 'react-query';
import axios from 'axios';

import { backendRequestHeaders, getBackendBaseUrl } from '@/api/backendAuth';
import { useAuth } from '@/modules/Auth/hooks/useAuth';

async function deleteAPICredentialsById(credentialId: string, token: string | undefined) {
  const response = await axios.delete(`${getBackendBaseUrl()}/api-credentials/${credentialId}`, {
    headers: backendRequestHeaders(token),
  });
  return response.data;
}

export function useDeleteAPICredentialsById() {
  const { user } = useAuth();

  return useMutation<unknown, Error, string>((credentialId) =>
    deleteAPICredentialsById(credentialId, user?.signInUserSession.idToken.jwtToken),
  );
}
